module.exports = __webpack_public_path__ + "static/img/top.3694a817.png";